import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import { useEffect, useState } from 'react';

/* eslint-disable react/prop-types */
const Chart = ({ selectedMetal, selectedDuration }) => {
  const [fromDate, setFromDate] = useState('');
  const [res, setRes] = useState([]);

  useEffect(() => {
    const calculateFromDate = (duration) => {
      const today = new Date();

      if (duration === '1D') {
        today.setDate(today.getDate() - 1);
      } else if (duration === '1W') {
        today.setDate(today.getDate() - 7);
      } else if (duration === '1M') {
        today.setMonth(today.getMonth() - 1);
      } else if (duration === '3M') {
        today.setMonth(today.getMonth() - 3);
      } else if (duration === '6M') {
        today.setMonth(today.getMonth() - 6);
      } else if (duration === '1Y') {
        today.setFullYear(today.getFullYear() - 1);
      } else {
        throw new Error('Invalid duration');
      }

      const calculatedDate = today.toISOString().slice(0, 10); // Format as YYYY-MM-DD
      // console.log('Calculated Date:', calculatedDate); // Log the calculated date
      return calculatedDate;
    };

    const calculatedFromDate = calculateFromDate(selectedDuration);
    setFromDate(calculatedFromDate);

    const data = JSON.stringify({
      metalCode: selectedMetal,
      fromDate: calculatedFromDate,
    });

    // console.log(data, "data")

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://api.ebullion.in/price/chart',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setRes(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedMetal, selectedDuration]);

  // const formattedFromDate = new Date(fromDate).toLocaleDateString('en-GB', {
  //     day: '2-digit',
  //     month: 'short',
  //     year: 'numeric'
  // });
  const originalDate = new Date(fromDate);
  originalDate.setDate(originalDate.getDate());

  const reducedFormattedDate = originalDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  // console.log(reducedFormattedDate);

  // console.log(reducedFormattedDate,"@formattedFromDate")
  const options = {
    chart: {
      id: 'area-datetime',
      type: 'area',
      height: 350,
      width: 500,
      zoom: {
        autoScaleYaxis: true,
      },
    },
    title: {
      text: 'Pricing Chart',
      align: 'left',
    },
    yaxis: {
      title: {
        text: 'Price (INR)',
      },
    },
    // colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
    colors: ['#99834d', '#99834d', '#99834d', '#99834d', '#99834d'],
    stroke: {
      curve: 'straight',
      width: 3,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      x: {
        format: 'dd MMMM yyyy',
        // format: 'dd MMMM yyyy HH:mm:ss'
      },
    },
    xaxis: {
      type: 'datetime',
      min: new Date(reducedFormattedDate).getTime(),
      tickAmount: 6,
    },

    annotations: {
      yaxis: [
        {
          y: 30,
          borderColor: '#999',
          // label: {
          //     show: true,
          //     text: 'Support',
          //     style: {
          //         color: "#fff",
          //         background: '#00E396'
          //     }
          // }
        },
      ],
      xaxis: [
        {
          x: new Date(reducedFormattedDate).getTime(),
          borderColor: '#999',
          yAxisIndex: 0,
          // label: {
          //     show: false,
          //     text: 'Rally',
          //     style: {
          //         color: "#fff",
          //         background: '#775DD0'
          //     }
          // }
        },
      ],
    },
  };

  const series = [
    {
      name: ' INR / g',
      data: res,
    },
  ];

  return (
    <div className='area-line-chart'>
      <ReactApexChart
        options={options}
        series={series}
        type='area'
        height={350}
      />
    </div>
  );
};

export default Chart;
